export const device = {
  pc: `(min-width : 1140px)`,
  pcTab: `(min-width:640px)`,
  tablet: `(min-width : 640px) and (max-width : 1139px)`,
  mobile: `(max-width : 639px)`,
  tabMob: `(max-width : 1139px)`,
};
